module.exports = __webpack_public_path__ + "static/media/equalicare-img20.18d5bc83.png";